import React, { useState, useEffect } from 'react';
import { getPayments } from '../services/api';
import { FaEye } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';

const TrackPayments = () => {
  const [sort, setSort] = useState('createdAt');
  const [order, setOrder] = useState('desc');
  const [payments, setPayments] = useState([]);
  const [allPayments, setAllPayments] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [search, setSearch] = useState('');
  const [expandedRows, setExpandedRows] = useState({});
  const [filters, setFilters] = useState({
      courseTitle: '',
  });
  const navigate = useNavigate();
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [profileModalOpen, setProfileModalOpen] = useState(false);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
        const data = await getPayments();
        const all = Array.isArray(data) ? data : data.documents || [];
        setAllPayments(all);
      } catch (error) {
        console.error('Failed to fetch payments:', error);
      }
    };
    fetchPayments();
  }, []);

  useEffect(() => {
    const applyFilters = () => {
      let filtered = [...allPayments];

      if (filters.courseTitle)
        filtered = filtered.filter((b) => b.courseTitle === filters.courseTitle);

      if (search.trim()) {
        const s = search.toLowerCase();
        filtered = filtered.filter(b =>
          b.paymentId?.toLowerCase().includes(s) ||
          b.bookingId?.toLowerCase().includes(s) ||
          b.carId?.toLowerCase().includes(s) ||
          b.studentId?.toLowerCase().includes(s) ||
          b.schoolOwnerId?.toLowerCase().includes(s)
        );
      }

      // Sort
      filtered.sort((a, b) => {
        const dateA = a[sort]?.seconds || 0;
        const dateB = b[sort]?.seconds || 0;
        return order === 'asc' ? dateA - dateB : dateB - dateA;
      });

      const start = currentPage * 10;
      const paginated = filtered.slice(start, start + 10);

      setPayments(paginated);
      setPageCount(Math.ceil(filtered.length / 10));
    };

    applyFilters();
  }, [allPayments, filters, sort, order, search, currentPage]);

   const handleSortChange = (field) => {
       setSort(field);
       setOrder(order === 'asc' ? 'desc' : 'asc');
       setCurrentPage(0);
     };

    const handlePageChange = ({ selected }) => {
      setCurrentPage(selected);
    };

    const handleFilterChange = (e) => {
        setFilters({ ...filters, [e.target.name]: e.target.value });
        setCurrentPage(0);
      };

    const toggleRow = (id) => {
      setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
    };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-poppins text-driveeasy-blue dark:text-driveeasy-blue2 mb-4">Track Payments</h2>

      <div className="mb-4 flex flex-wrap items-center gap-4">
        <input
          type="text"
          placeholder="Search by name,id's ,course.."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="p-2 border rounded-md w-80 bg-white dark:bg-neutral-700 dark:border-neutral-600 dark:text-gray-200"
        />
        <select name="courseTitle" value={filters.courseTitle} onChange={handleFilterChange} className="p-2 border rounded-md bg-white dark:bg-neutral-700 dark:border-neutral-600 dark:text-gray-200">
          <option value="">All Courses</option>
          <option value="Complete Driving - With License">Course With License</option>
          <option value="Complete Driving - Without License">Course Without License</option>
        </select>
      </div>
      {/* Table */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white dark:bg-neutral-800 shadow rounded-lg text-sm border border-gray-100 dark:border-neutral-800">
          <thead>
            <tr className="bg-driveeasy-blue text-white dark:bg-neutral-700 dark:text-gray-200">
              <th className="p-3 text-left">Payment ID</th>
              <th className="p-3 text-left">Student ID</th>
              <th className="p-3 text-left">Booking ID</th>
              <th className="p-3 text-left">Course</th>
              <th className="p-3 text-left">Amount</th>
              <th className="p-3 text-left">Status</th>
              <th onClick={() => handleSortChange('createdAt')}>
                Date {sort === 'createdAt' && (order === 'asc' ? '↑' : '↓')}
              </th>
              <th className="p-3 text-left">Actions</th>
            </tr>
          </thead>
          <tbody>
            {payments.length > 0 ? payments.map((payment) => (
              <React.Fragment key={payment.paymentId}>
                <tr className="border-b border-gray-200 dark:border-neutral-700 hover:bg-gray-50 dark:hover:bg-neutral-700/70 text-black dark:text-gray-300">
                <td
                     className="p-3 text-driveeasy-blue hover:underline cursor-pointer"
                     onClick={() => {
                       setSelectedPayment(payment);
                       setProfileModalOpen(true);
                     }}
                 >{payment.paymentId}
                 </td>
                <td
                  className="p-3 text-driveeasy-blue underline cursor-pointer"
                  onClick={() => navigate(`/users?studentId=${payment.studentId}`)}
                >
                  {payment.studentId || 'N/A'}
                </td>
                <td
                  className="p-3 text-driveeasy-blue underline cursor-pointer"
                  onClick={() => navigate(`/bookings?bookingId=${payment.bookingId}`)}
                >
                  {payment.bookingId || 'N/A'}
                </td>
                <td className="p-3">
                    {payment.courseTitle === 'Complete Driving - With License' ? 'CD - With Course' :
                     payment.courseTitle === 'Complete Driving - Without License' ? 'CD - Without Course' :
                     payment.courseTitle || 'N/A'}
                  </td>
                <td className="p-3">₹{payment.amount}</td>
                <td className="p-3">
                  <span className={`px-2 py-1 rounded text-white ${payment.paymentStatus === 'SUCCESS' ? 'bg-red-500' : 'bg-green-500'}`}>
                    {payment.paymentStatus}
                  </span>
                </td>
                <td className="p-3">
                   {payment.createdAt?.seconds ? new Date(payment.createdAt.seconds * 1000).toLocaleDateString() : 'N/A'}
                 </td>
                <td className="p-3">
                 <button onClick={() => toggleRow(payment.paymentId)}>
                   <FaEye className={expandedRows[payment.paymentId] ? 'text-driveeasy-yellow' : 'text-driveeasy-blue'} />
                 </button>
               </td>
              </tr>
              {expandedRows[payment.paymentId] && (
                <tr>
                  <td colSpan="8" className="p-3 bg-gray-50 dark:bg-neutral-800 text-sm">
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <h4 className="text-driveeasy-blue font-semibold">Payment Details</h4>
                        <p>Instructor ID: {payment.instructorId}</p>
                        <p>School Owner ID: {payment.schoolOwnerId}</p>
                        <p>Car ID: {payment.carId}</p>
                        {payment.coupon && <p>Coupon: {payment.coupon}</p>}
                        {payment.giftCardCode && <p>Gift Card Code: {payment.giftCardCode}</p>}
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              </React.Fragment>
            )) : (
              <tr>
                <td colSpan="8" className="text-center p-4">No payments found.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {/* Pagination */}
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          pageCount={pageCount}
          onPageChange={handlePageChange}
          containerClassName={'flex justify-center mt-4 space-x-2'}
          pageClassName={'px-3 py-1 border rounded border-gray-200 dark:border-neutral-600 hover:bg-driveeasy-blue hover:text-white dark:text-gray-100'}
          activeClassName={'bg-driveeasy-blue text-white'}
          previousClassName={'px-3 py-1 border rounded border-gray-200 dark:border-neutral-700 hover:bg-driveeasy-blue hover:text-white dark:text-gray-100'}
          nextClassName={'px-3 py-1 border rounded border-gray-200 dark:border-neutral-700 hover:bg-driveeasy-blue hover:text-white dark:text-gray-100'}
        />
        {profileModalOpen && selectedPayment && (
           <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
             <div className="bg-white dark:bg-neutral-800 dark:text-gray-200 p-6 rounded-lg max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-xl border border-gray-200 dark:border-neutral-700">
               <h3 className="text-xl font-bold mb-4 text-driveeasy-blue">Full Details</h3>
               <div className="grid grid-cols-2 gap-4 text-sm">
                 <div>
                   <h4 className="font-semibold text-driveeasy-blue">Payment Info</h4>
                   <p><strong>Payment ID:</strong> {selectedPayment.paymentId || 'N/A'}</p>
                   <p><strong>Student ID:</strong> {selectedPayment.studentId || 'N/A'}</p>
                   <p><strong>Booking ID:</strong> {selectedPayment.bookingId || 'N/A'}</p>
                   <p><strong>School ID:</strong> {selectedPayment.schoolOwnerId || 'N/A'}</p>
                   <p><strong>Instructor ID:</strong> {selectedPayment.instructorId || 'N/A'}</p>
                   <p><strong>Car ID:</strong> {selectedPayment.carId || 'N/A'}</p>
                   <p><strong>Coupon:</strong> {selectedPayment.coupon || 'N/A'}</p>
                   <p><strong>Gift Code:</strong> {selectedPayment.giftCardCode || 'N/A'}</p>
                 </div>
               </div>
    
               <div className="mt-4 flex justify-end">
                 <button
                   className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600"
                   onClick={() => setProfileModalOpen(false)}
                 >
                   Close
                 </button>
               </div>
             </div>
           </div>
         )}
    </div>
  );
};

export default TrackPayments;
